import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';

import { CoreModule } from '@app/core/core.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { registerLocaleData } from '@angular/common';
import localeBg from '@angular/common/locales/bg';
import localeDe from '@angular/common/locales/de';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ActivationModule } from './activation/activation.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

registerLocaleData(localeBg);
registerLocaleData(localeDe);

@NgModule({
  imports: [
    // angular
    BrowserAnimationsModule,
    BrowserModule,
    // core & shared
    CoreModule,

    // app
    AppRoutingModule,
    ActivationModule,
    StoreDevtoolsModule.instrument({

    })

  ],
  declarations: [AppComponent],
  providers: [
    { provide: LOCALE_ID, useValue: 'bg-BG' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
